<template>
  <div class="sp-tabs h-full">
    <el-row class="h-full">
      <el-col class="h-full" :span="4">
        <sp-tabs-menu v-model="local_value" :menus="tabs" />
      </el-col>
      <el-col class="h-full" :span="20">
        <el-scrollbar class="h-full" wrap-style="overflow-x:hidden;">
          <keep-alive>
            <slot v-bind="{ tabs, activeIndex: local_value }" name="default" />
          </keep-alive>
        </el-scrollbar>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'SpTabs',
  components: {
    'sp-tabs-menu': () => import('@/components/sp-tabs/src/menu.vue'),
  },
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      local_value: 0,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.local_value = val;
      },
    },
    local_value() {
      this.$emit('update:value', this.local_value);
      this.$emit('tabClick', this.local_value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./style/index.scss";
</style>
